module.exports = __webpack_public_path__ + "static/img/logo.2e6aab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay/logo.png
// module id = YXTd
// module chunks = 1